/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from 'react'
import GlobalDailybreakContext from 'global/context/context'
import analytics from 'global/AnalyticsData'
import { ingestUtmParametersFromUrl, getUtmParameters } from 'util/utm'
import { languageFromPath } from 'util/languageFromPath'
import { flushLanguageSwitch } from 'global/layout/LanguageSwitcher'
import { I18nProvider } from 'i18n/I18nProvider'

const fingerPrintUrl = 'https://dailybreak-scripts.s3.amazonaws.com/fv3.js'

const injectFingerprintJS = async () => {
  const script = document.createElement('script')
  script.async = true
  script.defer = true

  script.innerHTML = `
    (async () => {
      try {
        const FingerprintJS = await import("${fingerPrintUrl}");
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        window.fingerPrintResult = result;
      } catch (error) {
        console.error('Error loading FingerprintJS:', error);
      }
    })();`

  document.body.appendChild(script)
}

export const wrapRootElement = ({ element }) => {
  return (
    <I18nProvider>
      <GlobalDailybreakContext>{element}</GlobalDailybreakContext>
    </I18nProvider>
  )
}

export const onPreRouteUpdate = async ({ location, prevLocation }) => {
  location &&
    typeof window !== 'undefined' &&
    (await ingestUtmParametersFromUrl(location.search))

  if (typeof window !== 'undefined') {
    analytics.setStep({})
    analytics.setBreak({})

    // The language the reader is actually on, for sites that serve one page per language
    // under a URL prefix (BR-5583). Undefined everywhere else, and an absent key is left
    // out of the push rather than sent empty.
    const language = languageFromPath(location?.pathname)
    analytics.setLanguage(language)

    // Attribution has to work for anonymous visitors, which is most of a campaign site's
    // traffic. `setUser` merges these too, but only once somebody signs in.
    const utms = await getUtmParameters()
    analytics.setUtms(utms?.parameters)

    analytics.trackEvent('page_view')

    // A language switch is a full navigation, so the switcher cannot report it before the
    // page unloads. It leaves a record instead, and the landing page emits it.
    flushLanguageSwitch(language)
  }
}

var injectedFingerprintJS = false

export const onRouteUpdate = (args, pluginOptions = {}) => {
  if (!injectedFingerprintJS) {
    injectFingerprintJS()
    injectedFingerprintJS = true
  }

  //forcing consent for cookiebot
  //  if (window.Cookiebot) {
  //  if (window.Cookiebot.hasResponse === false) {
  //  window.Cookiebot.submitCustomConsent(true, true, true)
  // }
  // }
}
